import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getBreachRiskClassificationList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_RISK_CLASSIFICATIONS}?${stringifyParams(queryParams)}`
	);
};

export const getBreachRiskClassificationListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_RISK_CLASSIFICATIONS}?${stringifyParams(params)}`
	);
};

export const getBreachRiskClassificationById = id => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_RISK_CLASSIFICATION}${id}`
	);
};

export const addNewBreachRiskClassificationApi = breachRiskClassification => {
	return apiClient.create(
		`${INSPECTION_BASE}${url.POST_BREACH_RISK_CLASSIFICATION}`,
		breachRiskClassification
	);
};

export const updateBreachRiskClassificationApi = breachRiskClassification => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_BREACH_RISK_CLASSIFICATION}${breachRiskClassification._id}`,
		breachRiskClassification
	);
};

export const deleteBreachRiskClassificationApi = id => {
	return apiClient.delete(
		`${INSPECTION_BASE}${url.DELETE_BREACH_RISK_CLASSIFICATION}${id}`
	);
};

export const checkBreachRiskClassificationExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${INSPECTION_BASE}${url.CHECK_BREACH_RISK_CLASSIFICATION_EXISTS}?${stringifyParams(
				queryParams
			)}`
		)
		.then(response => ({ exists: response && response.length > 0 }))
		.catch(() => ({ exists: false }));
};
